import { errorMessage } from "./errorMessage";
import { i18n } from "./init";
/**
 * The UI copy for a solver error body (`response.data.error`). Codes that
 * carry `params` interpolate them under `errors:solver.<code>`; every other
 * code resolves through `errorMessage(code, "solver")`, so an unknown or
 * missing code still lands on `errors:solver.generic`.
 */
export const solverErrorMessage = (body) => {
    const code = typeof body?.code === "string" ? body.code : undefined;
    const params = body?.params ?? {};
    const translate = i18n.t;
    if (code === "TOO_FEW_PLAYERS_FOR_FILTER" &&
        typeof params.found === "number" &&
        typeof params.needed === "number") {
        const values = params.values ?? [];
        const labels = params.labels ??
            values.map((value) => {
                const key = `errors:solver.filterValues.${params.field}.${value}`;
                return i18n.exists(key) ? translate(key) : String(value);
            });
        return translate("errors:solver.TOO_FEW_PLAYERS_FOR_FILTER", {
            count: params.found,
            needed: params.needed,
            labels: labels.join(", "),
            rating: values.length ? Math.min(...values) : undefined,
            context: params.field === "ovr_rating" ? "ovr_rating" : undefined,
        });
    }
    if (code === "INCLUDED_PLAYER_UNKNOWN" &&
        typeof params.position === "number") {
        return translate("errors:solver.INCLUDED_PLAYER_UNKNOWN", {
            position: params.position,
        });
    }
    return errorMessage(code, "solver");
};
//# sourceMappingURL=solverErrorMessage.js.map